import { useContext } from "react"

import {
    AuthenticationStateContext,
    AuthenticationDispatchContext,
    AuthenticationState,
    AuthenticationDispatch,
} from "./AuthenticationContext.context"

/**
 * Returns the read-only authentication state:
 * `{ accessToken, refreshToken, isAuthenticated, isRefreshing }`
 */
export const useAuthState = (): AuthenticationState =>
    useContext(AuthenticationStateContext)

/**
 * Returns the authentication dispatch actions:
 * `{ login, logout }`
 */
export const useAuthDispatch = (): AuthenticationDispatch =>
    useContext(AuthenticationDispatchContext)
